import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import moment from "moment";
import * as ajaxActions from "../../../actions/ajaxCounterActions";
import { throwException } from "../../../actions/exceptionActions";
import * as layoutActions from "../../../actions/e-loketLayoutActions";
import redirector from "../../../util/redirector";
import * as types from "../../../constants/ComponentConstants";
import Section from "../../common/Section";
import ToelatingPerGemeenteForm from "./ToelatingPerGemeenteForm";
import ToelatingPerGemeentePageHelper from "./ToelatingPerGemeentePageHelper";
import ScrollToFirstErrorComponent from "../../common/ScrollToFirstErrorComponent";
import {getTochtTypeText} from "../../../util/tochtTypeHelper";
class ToelatingPerGemeentePage extends ScrollToFirstErrorComponent {
	constructor(props, context) {
		super(props, context, true);

		this.state = {
			model: null,
			errors: null,
			hasUnsavedChanges: false,
			shouldScrollToFirstError: false
		};

		this.filesHelper = null;
		this.pageHelper = new ToelatingPerGemeentePageHelper(this, redirector);
	}

	componentDidMount = () => {
		super.componentDidMount();
		this.pageHelper.init();
	};

	handleOnUploadFiles = (component, files) => this.filesHelper.uploadFiles(component, files);
	handleOnDeleteFile = (component, file) => this.filesHelper.deleteOneFile(component, file);
	handleOnSave = () => this.pageHelper.save();
	handleOnChange = (event, toelatingId) => this.pageHelper.change(event, toelatingId);
	handleOnGetError = (propertyName, toelatingId) => this.pageHelper.getErrorForProperty(propertyName, toelatingId);
	handleOnAnnuleer = () => this.pageHelper.annuleer();

	isReadyToRender = () => {
		return this.state.model &&
			this.state.fileComponents;
	};

	render() {
		if (!this.isReadyToRender())
			return null;

		const state = this.state;
		const props = this.props;
		const model = state.model;
		const disabled = state.disabled;
		const fileComponents = state.fileComponents;
		const downloadFileUrl = this.filesHelper.getFileDownloadUrl();
		const color = types.COLOR_BLUE;
		const bewijsstukkenFileTypes = props.bewijsstukkenFileTypes;
		const datumTocht = moment(model.tochtDatum).format("DD/MM/YYYY");
		const tochtTypeText = getTochtTypeText();
		return (
			<Section
				title={<h3><h3>Geef de goedkeuring van {model.toelating.gemeenteNaam} in voor de {tochtTypeText.TochtTypeSingular}{model.heeftBepijling ? " met bepijling" : ''}</h3><h3>{model.svlDossierId} {model.tochtNaam}</h3><h3>op {datumTocht}</h3></h3>}
				color={color}>
				<ToelatingPerGemeenteForm
					model={model}
					bewijsstukkenFileTypes={bewijsstukkenFileTypes}
					fileComponents={fileComponents}
					getError={this.handleOnGetError}
					onUploadFiles={this.handleOnUploadFiles}
					onDeleteFile={this.handleOnDeleteFile}
					downloadFileUrl={downloadFileUrl}
					onChange={this.handleOnChange}
					onSave={this.handleOnSave}
					onAnnuleer={this.handleOnAnnuleer}
					disabled={disabled}
					color={color}
					validationMessageType={this.state.validationMessageType}
				/>
			</Section>
		);
	}
}

ToelatingPerGemeentePage.propTypes = {
	loadLayout: PropTypes.func
};

function mapStateToProps(state, ownProps) {
	const bewijsstukkenFileTypes = state.settings.fileTypes[types.FileComponentNames.BEWIJSSTUKKEN_TOELATING_];

	return {
		bewijsstukkenFileTypes: bewijsstukkenFileTypes
	};
}

function mapDispatchToProps(dispatch, ownProps) {
	return {
		loadLayout: bindActionCreators(layoutActions.loadVTTPerGemeentePageLayout, dispatch),
		ajaxActions: bindActionCreators(ajaxActions, dispatch),
		throwException: bindActionCreators(throwException, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(ToelatingPerGemeentePage);
